export const HIDE_HEADER = className => `Hide ${className}?`

export const HIDE_WARNING = "You'll lose access to this small group."

export const HIDE_MESSAGE =
  "Your class data will still be saved in your school's reporting. Hide small groups when you're finished teaching them to reduce clutter on your dashboard."

export const HIDE_CONFIRM = 'Got it'

export const HIDE_SUBMIT = 'Hide Small Group'

export const HIDE_CANCEL = 'Cancel'
